module.exports = __webpack_public_path__ + "static/thumb-63e6151314364776f3045becf4ad081b.png";